import { useState, useEffect, Fragment } from 'react';
import {
  assemble,
  correctInternalLink,
  createFilterData,
  createFilterDataProductFamily,
  getAlgoliaDatasetValue,
  increaseUntilDivisibleByThree,
  isItUndefined,
  isLinkAbsolute,
  marketoOptions as options,
  showPart,
  stripHtml,
  getAlgoliaIndex,
  handleGoTo,
  modifyLinks,
  createFiltersFromRedirect,
} from '../../util/DataUtil';
import { useRouter } from 'next/router';
import { getLanguage, useWindowSize } from '../../util/PageUtil';
import { brandColor, getClassTextForColor } from '../../util/ColorUtil';
import ResourceFilter from '../resources/resource-filter';
import { useDispatch, useSelector } from 'react-redux';
import { setLocalStorageRedux } from '../../store/localStorageSlice';
import { correctUrlFormatForRouting } from '../../util/DataUtil';

const onMouseEnter = (item, setHover) => {
  setHover(item);
};

const onMouseLeave = (item, setHover) => {
  setHover(false);
};

const handleLoadMore = (
  page,
  setPage,
  algoliaData,
  setHitsPerPage,
  hitsPerPage
) => {
  setHitsPerPage(hitsPerPage + 9);
};

const handleShowLess = (
  page,
  setPage,
  setHitsPerPage,
  hitsPerPage,
  anchorToTop,
  setAnchorToTop
) => {
  if (hitsPerPage > 8) {
    setHitsPerPage(8);
    setAnchorToTop(anchorToTop + 1);
  }
};

const handleShowAll = (page, setPage, setHitsPerPage) => {
  setPage(0);
  setHitsPerPage(10000);
};

//function for making product card to be right clickable
const handleContextMenu = (e, url) => {
  e.preventDefault();

  if (url) {
    let absoluteUrl = url;

    // Check if the url is a full URL
    if (!url.startsWith('http')) {
      // If it's not a full URL, construct the absolute URL using the current origin
      absoluteUrl = window.location.origin + url;
    } else {
      // If it's a full URL, extract the path and construct the absolute URL
      const path = new URL(url).pathname;
      absoluteUrl = window.location.origin + path;
    }
    window.open(absoluteUrl, '_blank');
  } else {
    console.error('Internal link is not valid:', url);
  }
};

const renderCards = (cards, router, hover, setHover, backgroundColor) => {
  if (!cards) {
    return;
  }

  return cards.map((item, key) => {
    if (
      isItUndefined(item?.field_card_title) &&
      isItUndefined(item?.field_card_description)
    ) {
      return (
        <div
          key={'cards-product-family-key' + key}
          className={'div-product-family-link card'}
          onMouseEnter={() => onMouseEnter(item, setHover)}
          onMouseLeave={() => onMouseLeave(item, setHover)}
          onClick={() =>
            handleGoTo(isItUndefined(item?.field_card_url), router)
          }
          style={{ backgroundColor: backgroundColor }}
          onContextMenu={(e) =>
            handleContextMenu(e, item?.field_card_url?.[0]?.value)
          }
        >
          <div className={'card-inner-container'}>
            <div>
              <h3 className={'card-title'}>
                {isItUndefined(item?.field_card_title)}
              </h3>
              <p
                className={'card-description'}
                dangerouslySetInnerHTML={{
                  __html: stripHtml(
                    isItUndefined(item?.field_card_description)
                  ),
                }}
              />
            </div>
            {/*{*/}
            {/*    hover.id === item.id ? <img src={'/images/swap.svg'} alt={'arrows'} /> : <img src={'/images/doublearrows.svg'} alt={'arrows'} />*/}
            {/*}*/}
            <img
              className={'top'}
              src={'/images/doublearrows.svg'}
              alt={'arrows'}
            />
            <img className={'bottom'} src={'/images/swap.svg'} alt={'arrows'} />
          </div>
        </div>
      );
    }
  });
};

const renderCertifications = (certifications) => {
  if (!certifications) {
    return;
  }

  if (typeof certifications === 'string') {
    return (
      <div className={'certifications'}>
        <img alt={'icon'} src={'/images/checked-circle-white.svg'} />
        <p>{certifications}</p>
      </div>
    );
  } else {
    return certifications.map((i, key) => {
      return (
        <div className={'certifications'} key={key}>
          <img alt={'icon'} src={'/images/checked-circle-white.svg'} />
          <p>{i}</p>
        </div>
      );
    });
  }
};

const renderAlgoliaCards = (
  cards,
  router,
  hover,
  setHover,
  algoliaData,
  backgroundColor,
  page,
  setPage,
  clearAll,
  setHitsPerPage,
  setAnchorToTop,
  anchorToTop,
  hitsPerPage,
  isFilterActive,
  data,
  lang
) => {
  if (!cards) {
    return;
  }

  let result = [];

  let numberOfIterations = increaseUntilDivisibleByThree(cards.length) - 1;
  if (hitsPerPage !== 8) {
    if (numberOfIterations == -1) {
      numberOfIterations = 2;
    }
  }
  for (let item in cards) {
    const formattedUrl = correctUrlFormatForRouting(cards[item]?.url);
    result.push(
      <div
        key={item}
        className={'div-product-family-link card'}
        onMouseEnter={() => onMouseEnter(item, setHover)}
        onMouseLeave={() => onMouseLeave(item, setHover)}
        onClick={() => handleGoTo(cards[item]?.url, router, lang)}
        onContextMenu={(e) => handleContextMenu(e, formattedUrl.url)}
        style={{ backgroundColor: backgroundColor }}
      >
        <div className={'card-inner-container'}>
          <div>
            <h3 className={'card-title'}>
              {cards[item]?.category_name} {cards[item]?.title}
            </h3>
            <p
              className={'card-description'}
              dangerouslySetInnerHTML={{
                __html: stripHtml(cards[item]?.field_address_location),
              }}
            />
            <div className={'certifications-wrapper'}>
              {renderCertifications(cards[item]?.primary_source_language)}
            </div>
          </div>
          {/*<img className={'top'} src={'/images/doublearrows.svg'} alt={'arrows'} />*/}
          <img className={'bottom'} src={'/images/swap.svg'} alt={'arrows'} />
        </div>
      </div>
    );
  }

  if (cards.length == algoliaData.nbHits || isFilterActive) {
    for (let index = 0; index < numberOfIterations; index++) {
      result.push(
        <div
          key={`blank-${index}`}
          className={'div-product-family-link card'}
          style={{ backgroundColor: backgroundColor, cursor: 'default' }}
          //  onContextMenu={(e) => handleContextMenu(e, item)}
        >
          <div className={'card-inner-container'}>
            <div>
              <h3 className={'card-title'}></h3>
              <p
                className={'card-description'}
                dangerouslySetInnerHTML={{ __html: '' }}
              />
              <div className={'certifications-wrapper'}></div>
            </div>
          </div>
        </div>
      );
    }
  }

  if (cards.length >= 8) {
    result.push(
      <div className={'card'}>
        <div className={'load'}>
          {algoliaData.page + 1 !== algoliaData.nbPages &&
          algoliaData.nbHits !== 0 &&
          algoliaData.nbHits > 8 ? (
            <Fragment>
              <p
                className={'text'}
                onClick={() =>
                  handleLoadMore(
                    page,
                    setPage,
                    algoliaData,
                    setHitsPerPage,
                    hitsPerPage
                  )
                }
              >
                {isItUndefined(data?.global?.field_load_more_text)}
              </p>
              {
                <p
                  className={'show-all'}
                  onClick={() => handleShowAll(page, setPage, setHitsPerPage)}
                >
                  {isItUndefined(data?.global?.field_show_all_text_translation)}
                </p>
              }
            </Fragment>
          ) : (
            <Fragment>
              {/*<p className={'text'}>Show Less</p>*/}
              <p
                className={'text'}
                onClick={() => {
                  clearAll();
                  setAnchorToTop(anchorToTop + 1);
                }}
              >
                {isFilterActive
                  ? isItUndefined(data?.global?.field_celar_filte?.text)
                  : isItUndefined(data?.global?.field_show_less_text)}
              </p>
              {isFilterActive ? (
                <p
                  className={'show-all'}
                  onClick={() =>
                    handleShowLess(
                      page,
                      setPage,
                      setHitsPerPage,
                      hitsPerPage,
                      anchorToTop,
                      setAnchorToTop
                    )
                  }
                >
                  {isItUndefined(data?.global?.field_show_less_text)}
                </p>
              ) : (
                <></>
              )}
            </Fragment>
          )}
        </div>
      </div>
    );
  }

  return result;
};

const ProductFamily = (data) => {
  if (!data) {
    return;
  }
  const [hover, setHover] = useState(false);
  const [algoliaData, setAlgoliaData] = useState([]);
  const [facetFilters, setFacetFilters] = useState([]);
  const [page, setPage] = useState(0);
  const [showMore, setShowMore] = useState([]);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [filterProps, setFilterProps] = useState([]);
  const [languageFilter, setLanguageFilter] = useState([]);
  const [applyFilter, setApplyFilter] = useState(false);
  const [query, setQuery] = useState([]);
  const [filter, setFilter] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [hitsPerPage, setHitsPerPage] = useState(8);
  const router = useRouter();
  const windowSize = useWindowSize();
  const [anchorToTop, setAnchorToTop] = useState(0);
  const myLocalStorage = useSelector(setLocalStorageRedux);

  let lng =
    typeof window !== 'undefined' ? getLanguage(window.location.hostname) : '';
  let facetFiltersArray = [];
  let categoryName = [];
  let lngArray = [];
  let algoliaDataset =
    getAlgoliaDatasetValue(
      isItUndefined(data.children?.field_choose_algolia_dataset)
    ) + getAlgoliaIndex();

  let state = {
    backgroundColor: brandColor(
      isItUndefined(data.children?.field_background_color)
    ),
    textColor: getClassTextForColor(
      isItUndefined(data.children?.field_background_color)
    ),
    mainTitle: isItUndefined(data.children?.field_product_family_main_title),
    topLevelTitle: isItUndefined(data.children?.field_top_level_title),
    topLevelDescription: isItUndefined(
      data.children?.field_top_level_description
    ),
    url: isItUndefined(data.children?.field_top_level_url, 'uri'),
    urlTitle: isItUndefined(data.children?.field_top_level_url, 'title'),
    useAlgoliaData: isItUndefined(data.children.field_use_algolia_data),
    cards: data.children?.field_card?.product_family_card,
    algoliaCards: showMore,
    filterCategories: data.categories,
    filterLocations: data.locations,
  };

  useEffect(() => {
    setIsLoading(true);
    fetchAlgoliaData();
  }, []);

  useEffect(() => {
    if (anchorToTop > 0) {
      let doc = document.getElementById('product-family');
      window.scrollTo({ top: doc?.offsetTop - 150, behavior: 'smooth' });
    }
  }, [anchorToTop]);

  useEffect(() => {
    if (!lng) {
      return;
    }

    if (state.useAlgoliaData === '1') {
      fetchAlgoliaData();
    }
  }, [applyFilter, query, filter]);

  useEffect(() => {
    if (page > 0) {
      fetchAlgoliaPagination();
    } else if (page === 0) {
      fetchAlgoliaData();
    }
  }, [page]);

  useEffect(() => {
    // setPage(page + 1)
    fetchAlgoliaData();
  }, [hitsPerPage]);

  useEffect(() => {
    // let localFilter = router.query.type !== undefined ? router.query.type :
    //     router.query.category !== undefined ? router.query.category : '';

    let localFilter = router.query;

    if (typeof window !== 'undefined') {
      // localFilter.length > 0 ? triggerFilterFromRedirect([{name: localFilter}]) : clearAll()
      hasNonEmptyProperties(localFilter)
        ? triggerFilterFromRedirect(localFilter)
        : clearAll();
    }
  }, [myLocalStorage]);

  const fetchAlgoliaData = () => {
    // let url = createFilterData(lngArray, facetFiltersArray, facetFilters, query, 8, page, lng, algoliaDataset);
    let url = createFilterDataProductFamily(
      lngArray,
      facetFiltersArray,
      facetFilters,
      query,
      hitsPerPage,
      page,
      lng,
      algoliaDataset,
      categoryName
    );

    const fetchAlgolia = async () => {
      await fetch(url, options)
        .then((response) => response.json())
        .then((newResponse) => {
          setShowMore(newResponse.hits);
          setAlgoliaData(newResponse);
          setIsLoading(false);
        });
    };
    fetchAlgolia();
  };

  const fetchAlgoliaPagination = () => {
    // let url = createFilterData(lngArray, facetFiltersArray, facetFilters, query, 100000, page, lng, algoliaDataset);
    let url = createFilterDataProductFamily(
      lngArray,
      facetFiltersArray,
      facetFilters,
      query,
      8,
      page,
      lng,
      algoliaDataset,
      categoryName
    );

    const fetchAlgolia = async () => {
      await fetch(url, options)
        .then((response) => response.json())
        .then((newResponse) => {
          setShowMore((previousResponse) => [
            ...previousResponse,
            ...newResponse.hits,
          ]);
          setAlgoliaData(newResponse);
        });
    };

    fetchAlgolia();
  };

  const triggerFilterFromRedirect = (filter) => {
    let filters = createFiltersFromRedirect(filter, data?.categories);
    triggerFilter(filters);
    setApplyFilter(true);
    setQuery([]);
  };

  function hasNonEmptyProperties(obj) {
    for (const key in obj) {
      if (
        key !== 'url' &&
        obj[key] !== null &&
        obj[key] !== undefined &&
        obj[key] !== ''
      ) {
        return true;
      }
    }
    return false;
  }

  const triggerFilter = (filters) => {
    setFilterProps(filters);

    let searchFilters = [];
    for (let filter of filters) {
      // searchFilters.push(filter.field_source_translation);
      searchFilters.push(filter);
    }

    setFacetFilters(searchFilters);
    setPage(0);
    setHitsPerPage(8);
    setApplyFilter(false);
  };

  const handleSearch = (search) => {
    setQuery(search.length !== 0 ? [search] : []);
    // setFilterProps([]);
    // setFacetFilters([]);
    setPage(0);
    setApplyFilter(false);
  };

  const clearQuery = () => {
    setQuery([]);
    setIsSearchActive(false);
    setIsFilterActive(true);
  };

  const clearAll = () => {
    setFilterProps([]);
    triggerFilter([]);
    setLanguageFilter([]);
    // setQuery([]);
    if (query.length > 0) {
      setQuery([]);
    }
    setShowMore([]);
    setFilter(!filter);
    setPage(0);
    setHitsPerPage(8);
    setIsFilterActive(false);
  };

  const lightenDarkenColor = (hex, lum) => {
    // validate hex string
    hex = String(hex).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    lum = lum || 0;

    // convert to decimal and change luminosity
    var rgb = '#',
      c,
      i;
    for (i = 0; i < 3; i++) {
      c = parseInt(hex.substr(i * 2, 2), 16);
      c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
      rgb += ('00' + c).substr(c.length);
    }

    return rgb;
  };

  return (
    <div
      id={'product-family'}
      style={{ backgroundColor: state.backgroundColor }}
      className={state.textColor}
    >
      {state.useAlgoliaData === '1' && (
        <ResourceFilter
          clearQuery={clearQuery}
          isSearchActive={isSearchActive}
          isFilterActive={isFilterActive}
          setIsSearchActive={setIsSearchActive}
          setIsFilterActive={setIsFilterActive}
          search={isItUndefined(data.global.field_search_text_translation)}
          // title={isItUndefined(data.field_filter_resources)}
          filterProps={filterProps}
          triggerFilter={triggerFilter}
          data={assemble(data.categories)}
          onSearchChange={handleSearch}
          handleFilterApply={setApplyFilter}
          searchQuery={query}
          setQuery={setQuery}
          languageFilter={languageFilter}
          setLanguageFilter={setLanguageFilter}
          screenWidth={windowSize.width}
          clearAll={clearAll}
          title={isItUndefined(data.global.field_filter_text)}
          setFilter={setFilter}
          filter={filter}
          cancelText={isItUndefined(data.global.field_cancel_text_translation)}
          applyFilterText={isItUndefined(data.global.field_apply_filters_text)}
          clearAllText={isItUndefined(data.global.field_clear_all_text)}
          selectedText={isItUndefined(data.global.field_selected_text)}
          seeMoreText={isItUndefined(data?.global?.field_see_more_text)}
          seeLessText={isItUndefined(data?.global?.field_see_less)}
          singleFilter={true}
        />
      )}
      {showPart(state.mainTitle) && (
        <div className={'inner-container'}>
          <div className={'title'}>
            <span
              dangerouslySetInnerHTML={{ __html: modifyLinks(state.mainTitle) }}
            />
          </div>
        </div>
      )}
      {state.useAlgoliaData === '0' &&
        showPart(
          state.topLevelTitle,
          state.topLevelDescription,
          state.url,
          state.urlTitle
        ) && (
          <div
            className={`top-level ${state.url === undefined ? 'top-level-no-hover' : ''}`}
            onClick={() => state.url && handleGoTo(state.url, router, lng)}
          >
            <div className={'inner-container'}>
              {showPart(state.topLevelTitle) && (
                <h2
                  className={'top-level-title'}
                  dangerouslySetInnerHTML={{
                    __html: stripHtml(state.topLevelTitle),
                  }}
                />
              )}
              <div className={'top-level-right'}>
                {showPart(state.topLevelDescription) && (
                  <p
                    className={'top-level-description'}
                    dangerouslySetInnerHTML={{
                      __html: stripHtml(state.topLevelDescription),
                    }}
                  />
                )}
                {showPart(state.url, state.urlTitle) && (
                  <a
                    className={'a-product-family-link top-level-link'}
                    href={correctInternalLink(state.url)}
                  >
                    {state.urlTitle}
                    <img
                      width={'auto'}
                      height={'auto'}
                      src={'/images/arrow-right-white.svg'}
                      alt={'scroll-arrow'}
                    />
                  </a>
                )}
              </div>
            </div>
          </div>
        )}
      <div
        className={'cards'}
        style={{
          backgroundColor: lightenDarkenColor(state.backgroundColor, -0.1),
        }}
      >
        {state.useAlgoliaData === '1' && isLoading === false ? (
          showMore?.length === 0 ? (
            <div
              className={'no-results-wrapper'}
              style={{ backgroundColor: state.backgroundColor }}
            >
              <div className={'inner-container'}>
                <div className={'no-results'}>
                  {isItUndefined(data.global.field_no_result_text)
                    ? isItUndefined(data.global.field_no_result_text)
                    : 'No results were found. Please check the spelling, reset any filters and try again.'}
                </div>
              </div>
            </div>
          ) : (
            renderAlgoliaCards(
              showMore,
              router,
              hover,
              setHover,
              algoliaData,
              state.backgroundColor,
              page,
              setPage,
              clearAll,
              setHitsPerPage,
              setAnchorToTop,
              anchorToTop,
              hitsPerPage,
              isFilterActive,
              data,
              lng
            )
          )
        ) : (
          renderCards(
            state.cards,
            router,
            hover,
            setHover,
            state.backgroundColor
          )
        )}
      </div>
    </div>
  );
};

export default ProductFamily;
